import { render, staticRenderFns } from "./NYTConnectionsToday.vue?vue&type=template&id=df331818&scoped=true"
import script from "./NYTConnectionsToday.js?vue&type=script&lang=js&external"
export * from "./NYTConnectionsToday.js?vue&type=script&lang=js&external"
import style0 from "./NYTConnectionsToday.scss?vue&type=style&index=0&id=df331818&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df331818",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,NYTLatest: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTLatest/NYTLatest.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,NYTLatestList: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTLatestList/NYTLatestList.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
